module.exports = __webpack_public_path__ + "images/stickers/taco-trophy@2x.399015dd07efc7557cc3.png";